import templateStr from 'text!./bop-building-header.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            displayName: '&',
            locationId: '&',
            buildingId: '&',
            isAccordionOpen: '=',
            showActions: '=',
            wide: '&',
            onRemove: '&',
            onEdit: '&'
        },
        controller: function controller($scope) {
            $scope.editBuilding = function () {
                if (typeof $scope.onEdit() === 'function') {
                    $scope.onEdit()();
                }
            };

            $scope.removeBuilding = function () {
                if (typeof $scope.onRemove() === 'function') {
                    $scope.onRemove()();
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/directives/bop-building-directive/BOPBuildingHeader.js
// module id = 973
// module chunks = 0